export default __webpack_public_path__ + "static/media/icon-info.b17cf677.svg";